(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvon-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orvon-comparison')) {
    customElements.define('orvon-comparison', class OrvonComparison extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.orvon-transform__range');
        this.hotspot = this.querySelector('.orvon-transform__hotspot');
        if (!this.range) return;

        this.update = () => {
          const position = Number(this.range.value);
          this.style.setProperty('--comparison-position', `${position}%`);
          this.range.setAttribute('aria-valuetext', `${position} percent before, ${100 - position} percent after`);

          if (this.hotspot) {
            const hotspotPosition = Number(this.hotspot.dataset.hotspotX);
            this.hotspot.hidden = position >= hotspotPosition - 1;
          }
        };

        this.range.addEventListener('input', this.update);
        this.update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
